import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../../../../../api/agent";
import { AppResponse } from "../../../../../models/app/AppResponse";
import { ShoppingPortalSetting } from "../../../../../models/features/ShoppingPortal/ShoppingPortalDto";
import {
  PortalSettingRule,
  RuleActionType,
} from "../../../../../models/features/ShopifySetting/Portal Setting Rules/PortalSettingRules";

export const shoppingPortalSettingApi = createApi({
  reducerPath: "shoppingPortalSettingApi",
  baseQuery: axiosBaseQuery(),

  endpoints: (build) => ({
    addShoppingPortal: build.mutation<any, { data: any }>({
      query: ({ data }) => ({
        url: `api/ShoppingPortal/AddShoppingPortal`,
        method: "post",
        data: data,
      }),
    }),
    getShoppingPortal: build.query<AppResponse<ShoppingPortalSetting>, void>({
      query: () => ({
        url: `api/ShoppingPortal/GetShoppingPortal`,
      }),
    }),
    deletePortalImage: build.mutation<any, { Id: string }>({
      query: (data) => ({
        url: `api/ShoppingPortal/DeletePortalImage`,
        method: "delete",
        data: data,
      }),
    }),
    addShoppingPortalRule: build.mutation<any, { data: PortalSettingRule }>({
      query: ({ data }) => ({
        url: `api/ShoppingPortal/AddShoppingPortalRule`,
        method: "post",
        data: data,
      }),
    }),
    getShoppingPortalRules: build.query<AppResponse<PortalSettingRule>, void>({
      query: () => ({
        url: `api/ShoppingPortal/GetShoppingPortalRules`,
      }),
    }),
    portalRulesAction: build.mutation<
      any,
      { data: { id: string; actionType: RuleActionType } }
    >({
      query: ({ data }) => ({
        url: `api/ShoppingPortal/PortalRulesAction`,
        method: "post",
        data: data,
      }),
    }),
    setPortalEnable: build.mutation<
      any,
      { data: { PortalId: string; IsEnabled: boolean } }
    >({
      query: ({ data }) => ({
        url: `api/ShoppingPortal/EnablePortal`,
        method: "post",
        data: data,
      }),
    }),
  }),
});

export const {
  useGetShoppingPortalQuery,
  useAddShoppingPortalMutation,
  useDeletePortalImageMutation,
  useAddShoppingPortalRuleMutation,
  useGetShoppingPortalRulesQuery,
  usePortalRulesActionMutation,
  useSetPortalEnableMutation
} = shoppingPortalSettingApi;
export const shoppingPortalSettingReducer = shoppingPortalSettingApi.reducer;
